import { CellContainer, Flex, Text } from '@/_components';
import Link from 'next/link';
import { type FC } from 'react';
import type { CellUserNameProps } from './CellUserName.types';

export const CellUserName: FC<CellUserNameProps> = ({
  companyName,
  companyHash,
  children,
}) => {
  if (!companyName || !companyHash) return null;

  return (
    <CellContainer width={200}>
      <Flex gap={2} isYCentered={true}>
        <Link
          href={`/admin/${companyHash}`}
          data-testid="CellUserName-entity-link"
        >
          <Text type="tiny" lineClamp={2}>
            {companyName}
          </Text>
        </Link>
        {children}
      </Flex>
    </CellContainer>
  );
};
